var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"blank-container",class:{
    'has-background': _vm.$route.meta.is_has_bg,
    'blur-background': _vm.shouldBlurBackground && _vm.$route.meta.is_has_bg
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }